import { IKeynuaWidgetResponse } from '@app/core/models/biometrics.model';
import { createAction, props } from '@ngrx/store';

export const setBiometricsStep = createAction(
  '[Biometrics] Set Biometrics Step',
  props<{ step: number }>()
);

export const getKeynuaWidgetToken = createAction('[Biometrics] Get Keynua Widget Token');

export const successGetKeynuaWidgetToken = createAction(
  '[Biometrics] Success Get Keynua Widget Token',
  props<{ keynuaWidgetResponse: IKeynuaWidgetResponse }>()
);

export const failureGetKeynuaWidgetToken = createAction(
  '[Biometrics] Failure Get Keynua Widget Token',
  props<{ error: string }>()
);

export const getKeynuaWidgetStatus = createAction('[Biometrics] Get Keynua Widget Status');

export const successGetKeynuaWidgetStatus = createAction(
  '[Biometrics] Success Keynua Widget Status',
  props<{ keynuaWidgetResponse: IKeynuaWidgetResponse }>()
);

export const failureGetKeynuaWidgetStatus = createAction(
  '[Biometrics] Failure Get Keynua Widget Status',
  props<{ error: string }>()
);

export const resetKeynuaWidgetResponse = createAction('[Biometrics] Reset Keynua Widget Response');

export const setIsBiometricsFlag = createAction(
  '[Biometrics] Set IsBiometrics Flag',
  props<{ isBiometrics: boolean }>()
);
